import { render, staticRenderFns } from "./FreedomIcon.vue?vue&type=template&id=03823410&"
import script from "./FreedomIcon.vue?vue&type=script&lang=js&"
export * from "./FreedomIcon.vue?vue&type=script&lang=js&"
import style0 from "./FreedomIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports